import React, { Component } from 'react';
import { toast } from 'react-toastify';

import CustomModal from "../../components/Modal/CustomModal";

import { RetirarMateriaDir, NoRetirarMateriaDir } from "../../funciones/EstudiantesFunction";

class EstudiantesRetiroTableAdmin extends Component {
    state = { 
        boton: {
            icon: "fa fa-trash",
            text: "Retirar"
        },
        openModalDel: false,
        modalBtn1: {
            icon: "fa fa-check",
            text: "Si",
            disabled: false
        },
        modalBtn2: {
            icon: "fa fa-times",
            text: "No",
            disabled: false
        },
        openMaterias: false
    }

    modalDel = () => {
        let {data} = this.props;
        let {modalBtn1, openModalDel, modalBtn2} = this.state;

        let nombre2 = data.nombre_2;
        let apellido2 = data.apellido_2;
        if (nombre2 === null) nombre2 = "";
        if (apellido2 === null) apellido2 = "";

        let contenido = () => (
            <React.Fragment>
                <div>¿Deseas <strong className="text-danger"> CONFIRMAR</strong> el retiro de <strong>{`${data.materia_name} SECCION ${data.seccion}`}</strong> de <strong>{`${data.nacionalidad}${data.ci}`} - <span className="text-primary">{`${data.nombre_1} ${nombre2} ${data.apellido_1} ${apellido2}`}</span></strong>?</div>
            </React.Fragment>
        )

        let retirar = () => {
            if (modalBtn1.disabled === true) return null;

            this.setState({
                modalBtn1: {
                    icon: "fa fa-spinner fa-spin",
                    text: "Espera",
                    disabled: true
                }
            }, () => {
                RetirarMateriaDir(data.id, `${data.materia_name} SECCION ${data.seccion}`, () => {
                    this.setState({
                        openModalDel: false,
                        modalBtn1: {
                            icon: "fa fa-check",
                            text: "Si",
                            disabled: false
                        }
                    }, () => {
                        this.props.update()
                        toast.info("Se ha procesado correctamente el retiro de la materia del estudiante",{autoClose: 4000});
                    })
                })
            })
        }

        let noRetirar = () => {
            if (modalBtn2.disabled === true) return null;

            this.setState({
                modalBtn2: {
                    icon: "fa fa-spinner fa-spin",
                    text: "Espera",
                    disabled: true
                }
            }, () => {
                NoRetirarMateriaDir(data.id, `${data.materia_name} SECCION ${data.seccion}`, () => {
                    this.setState({
                        openModalDel: false,
                        modalBtn2: {
                            icon: "fa fa-times",
                            text: "No",
                            disabled: false
                        }
                    }, () => {
                        this.props.update()
                        toast.info("Se ha cancelado correctamente el retiro de la materia del estudiante",{autoClose: 4000});
                    })
                })
            })
        }

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className={modalBtn2.icon}></i> {modalBtn2.text}</React.Fragment>}
                boton1 = {<React.Fragment><i className={modalBtn1.icon}></i> {modalBtn1.text}</React.Fragment>}
                large = "medium"
                isopen =  {openModalDel}
                titulo = "Confirmación"
                contenido = {contenido()}      
                funcion1 = {retirar}
                funcion2 = {noRetirar}
            />
        );
    }

    render() { 
        let {data} = this.props;
        let {boton} = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        let nombre2 = data.nombre_2;
        let apellido2 = data.apellido_2;
        if (nombre2 === null) nombre2 = "";
        if (apellido2 === null) apellido2 = "";

        let materia = () => {
            if (this.props.tipo === "Solicitud") return (
                <div className="custom-alert-warning">
                    MATERIA: <strong>{`${data.materia_name} SECCION ${data.seccion}`}</strong>
                </div>
            )
        }

        return (
            <React.Fragment>
            <tr>
                <td style={styles}>
                    <div><strong>{`${data.nacionalidad}${data.ci}`} - <span className="text-danger">{`${data.nombre_1} ${nombre2} ${data.apellido_1} ${apellido2}`}</span></strong></div>
                    {materia()}
                </td>
                <td style={styles} align="center">{data.carrera_name}</td>
                <td style={styles}>
                    <button className="btn btn-primary" onClick={() => {this.setState({openModalDel: true})}} style={{borderWidth:1}}><i className={boton.icon}></i> {boton.text}</button>
                </td>
            </tr>
            {this.modalDel()}
            </React.Fragment>
        );
    }
}
 
export default EstudiantesRetiroTableAdmin;


// WEBPACK FOOTER //
// ./src/views/Administracion/EstudiantesRetiroTableAdmin.jsx